import clsx from "clsx";

import { Scene3D } from "nvs-types/dist/types/generated/contentful";
import AuthorableProduct from "nvs-3d-library/dist/components/NVSAuthorableProduct";
import { NvsLoadersTypes } from "nvs-3d-library/dist/components/NvsLoaders/types";
import { NvsBackgroundProps } from "nvs-3d-library/dist/components/Background/types";
import { NvsCameraControlsProps } from "nvs-3d-library/dist/components/NvsCameraControls/types";
import { SceneLightProps } from "nvs-3d-library/dist/components/Lighting/types";
import { SceneAssetProps } from "nvs-3d-library/dist/components/Assets3D/types";
import { HDRI } from "nvs-3d-library/dist/components/NVSAuthorableProduct/types";
import { useExpansionModalContext } from "@/src/components/Modal/ExpansionModal/ExpansionModalContext";
import { useIsTouchDevice } from "@/libs/utils";
import { EffectsMappingProps } from "nvs-3d-library/dist/components/Effects3D/types";

type CMSAuthoredTokenListingHeroProps = {
  product3DVisualData: NonNullable<Scene3D>;
  className?: string;
};

const CMSAuthoredTokenListingHero: React.FC<
  CMSAuthoredTokenListingHeroProps
> = ({ product3DVisualData, className }) => {
  const { isOpen } = useExpansionModalContext();
  const isTouch = useIsTouchDevice();
  const isTouchUnexpandedModal = !!isTouch && !isOpen;

  return (
    <AuthorableProduct
      className={clsx(
        className,
        isOpen && isTouch ? "touch-none" : "touch-auto",
      )}
      isAutoplayAndVisible={isTouchUnexpandedModal}
      hdri={product3DVisualData.hdri as HDRI}
      loaderType={product3DVisualData.loaderType as NvsLoadersTypes}
      background={product3DVisualData.background as NvsBackgroundProps}
      cameraControls={
        product3DVisualData.cameraControls as NvsCameraControlsProps
      }
      lights={product3DVisualData?.lightsCollection?.items as SceneLightProps[]}
      assets3d={
        product3DVisualData?.assets3DCollection?.items as SceneAssetProps[]
      }
      effects={
        product3DVisualData?.effectsCollection?.items as EffectsMappingProps
      }
    />
  );
};

export default CMSAuthoredTokenListingHero;
